var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 241,
    stroke: "#081F42",
    strokeWidth: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M338.035 233.916C350.026 240.846 350.026 258.154 338.035 265.084L206.007 341.391C194.007 348.327 179 339.667 179 325.807L179 173.193C179 159.333 194.007 150.673 206.007 157.609L338.035 233.916Z",
    fill: "#081F42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetStarted);
export default __webpack_public_path__ + "static/media/GetStarted.7b42098c3a5a3710cd439630cf752cff.svg";
export { ForwardRef as ReactComponent };